import { IconButton } from '@material-ui/core';
import React from 'react';
import {
  getBezierPath,
  getEdgeCenter,
  getMarkerEnd,
  getSmoothStepPath,
} from 'react-flow-renderer';

import { SmartEdge } from '@tisoap/react-flow-smart-edge';

import { EditIcon } from "..";

const foreignObjectSize = 40;

const onEdgeClick = (evt, id) => {
  evt.stopPropagation();
  alert(`remove ${id}`);
};

const canvas = document.createElement("canvas");

const getTextWidth = (text, font) => {
  const context = canvas.getContext("2d");
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}

const getElasticY = ({targetY, sourceY, maxS})=>{
  const diff = (targetY - sourceY) / 2;
  return diff < 0 ? Math.max(diff, -maxS) : Math.min(diff, maxS);
};

const getElasticPath = ({
  sourceX,
  sourceY,
  sourcePosition,
  targetX,
  targetY,
  targetPosition,
}) => {
  const maxS = 30;
  const desplazamiento = 14;
  const elasticY = getElasticY({targetY, sourceY, maxS});
  return `M ${sourceX} ${sourceY} L ${sourceX + desplazamiento} ${sourceY} L ${sourceX + desplazamiento} ${sourceY + elasticY} L ${targetX - desplazamiento} ${targetY - elasticY} L ${targetX - desplazamiento} ${targetY} L ${targetX} ${targetY}`;
}

export const EdgeButton = (props) => {

  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    data,
    arrowHeadType,
    markerEndId,
    label
  } = props;

  const etiqueta = data.etiqueta;

  
  /*const edgePath = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });*/

  const edgePath = getElasticPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  
  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
  const [edgeCenterX, edgeCenterY] = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  const textWidth = getTextWidth(etiqueta, "normal 10px Poppins, Helvetica, 'sans-serif'");

  return (
    <>
      <path
        id={id}
        style={{ strokeWidth: 2, ...style}}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
        
      />

      <g transform={`translate(${edgeCenterX - textWidth / 2} ${edgeCenterY - 10})`} class="react-flow__edge-textwrapper">
        <rect width={textWidth + 5} x="-2" y="-4" height="23" class="react-flow__edge-textbg" rx="2" ry="2" style={{fill: "#f2f2f2ee"}}></rect>
        <text class="react-flow__edge-text" y="7.5" dy="0.3em">{etiqueta}</text>

        <foreignObject x={textWidth*1.1} y="-4" width="22" height="22">
          <IconButton 
            onClick={()=>data.onEdit && data.onEdit(undefined, props)}
            
            style={{
              padding: 0,
              width: "100%",
              height: "100%",
              border: "0px solid white",
              backgroundColor: "#ffffffee",
            }}><EditIcon style={{width: 12, height: 12, fill: style.stroke || "#606060"}}/></IconButton>
        </foreignObject>
      </g>

      {/*
      <foreignObject
        width={foreignObjectSize}
        height={foreignObjectSize}
        x={edgeCenterX - foreignObjectSize / 2}
        y={edgeCenterY - foreignObjectSize / 2}
        className="edgebutton-foreignobject"
        requiredExtensions="http://www.w3.org/1999/xhtml"
      >
        <text class="react-flow__edge-text" y="7.5" dy="0.3em">{label}</text>
      </foreignObject>
      */}
    </>

  );
}